import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const offers = () => {
	carousel()
}

const carousel = () => {

	let els = document.querySelectorAll('[data-animation="offers-carousel"]')

	if (!els.length) return

	els.forEach(el => {

		el.style.opacity = 1

		let slides = el.querySelectorAll('.swiper-slide')

		gsap.fromTo(slides, {
			opacity: 0,
			xPercent: 100,
		}, {
			opacity: 1,
			xPercent: 0,
			duration: 1.6,
			stagger: 0.15,
			ease: 'power3.out',
			scrollTrigger: {
				trigger: el,
				start: 'top 70%',
				// markers: true,
			}
		})
	})
}

export default () => { }